"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDefinedGroupTitleWithButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var withState_1 = require("../hocs/withState");
var api_1 = require("../api");
var i18n_1 = __importDefault(require("../i18n"));
exports.UserDefinedGroupTitleWithButtons = (0, react_router_1.withRouter)((0, withState_1.withState)()([
    "userDefinedGroups",
    "editUserDefinedGroupUsers",
    "setEditUserDefinedGroupUsers",
    "setUserDefinedGroupsFetchRequest",
]).memoFC(function UserDefinedGroupTitleWithButtons(_a) {
    var _this = this;
    var id = _a.id, name = _a.name, editActionPath = _a.editActionPath, userDefinedGroups = _a.userDefinedGroups, editUserDefinedGroupUsers = _a.editUserDefinedGroupUsers, setEditUserDefinedGroupUsers = _a.setEditUserDefinedGroupUsers, setUserDefinedGroupsFetchRequest = _a.setUserDefinedGroupsFetchRequest, history = _a.history;
    var _b = (0, react_1.useState)(false), editName = _b[0], setEditName = _b[1];
    var _c = (0, react_1.useState)(name), newName = _c[0], setNewName = _c[1];
    (0, react_1.useEffect)(function () {
        setNewName(name);
    }, [name]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [editName ? (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { defaultValue: newName, onChange: function (e, _a) {
                    var value = _a.value;
                    return setNewName(value);
                } }) : name, editName ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "green", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, api_1.updateUserDefinedGroup)(id, newName)];
                            case 1:
                                _a.sent();
                                setUserDefinedGroupsFetchRequest(true);
                                setEditName(false);
                                return [2 /*return*/];
                        }
                    });
                }); }, children: i18n_1.default.save })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () { return setEditName(true); }, children: i18n_1.default.editName })), editUserDefinedGroupUsers === id ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "green", onClick: function () { return setEditUserDefinedGroupUsers(undefined); }, children: i18n_1.default.completeEditUsers })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { disabled: !!editUserDefinedGroupUsers, onClick: function () {
                    setEditUserDefinedGroupUsers(id);
                    if (!Object.keys(userDefinedGroups.filter(function (g) { return g.id === id; })[0].users).length)
                        history.push(editActionPath);
                }, children: i18n_1.default.editUsers })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!confirm(i18n_1.default.deleteConfirm)) return [3 /*break*/, 2];
                                return [4 /*yield*/, (0, api_1.removeUserDefinedGroup)(id)];
                            case 1:
                                _a.sent();
                                setUserDefinedGroupsFetchRequest(true);
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }, children: i18n_1.default.delete })] }));
}));
